import { useState } from 'react';
import AdminShell from '../../components/admin/AdminShell';
import { useToast } from '../../context/ToastContext';
import { adminAPI } from '../../utils/api';

const AdminAnnouncementsPage = () => {
  const [form, setForm] = useState({ title: '', message: '', target_class: '' });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState([]);
  const { success, error } = useToast();

  const handleSend = async (e) => {
    e.preventDefault();
    if (!form.title || !form.message) return error('Title and message are required.');
    setLoading(true);
    try {
      await adminAPI.createAnnouncement(form);
      success('Announcement sent to all students!');
      setSent(p => [{ ...form, created_at: new Date().toISOString() }, ...p]);
      setForm({ title: '', message: '', target_class: '' });
    } catch { error('Failed to send announcement.'); }
    finally { setLoading(false); }
  };

  return (
    <AdminShell title="Announcements" subtitle="Send messages to all students or specific classes">
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>

        {/* Create form */}
        <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '14px', padding: '20px' }}>
          <div style={{ fontSize: '14px', fontWeight: 800, marginBottom: '16px' }}>📢 New Announcement</div>
          <form onSubmit={handleSend}>
            <div style={{ marginBottom: '14px' }}>
              <label style={{ fontSize: '11px', fontWeight: 800, color: '#64748B', textTransform: 'uppercase', display: 'block', marginBottom: '5px' }}>Title *</label>
              <input value={form.title} onChange={e => setForm(p => ({ ...p, title: e.target.value }))}
                style={{ width: '100%', background: '#F7F8FC', border: '1.5px solid #E2E8F0', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', outline: 'none' }}
                placeholder="e.g. Platform maintenance tonight" required />
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={{ fontSize: '11px', fontWeight: 800, color: '#64748B', textTransform: 'uppercase', display: 'block', marginBottom: '5px' }}>Message *</label>
              <textarea value={form.message} onChange={e => setForm(p => ({ ...p, message: e.target.value }))}
                style={{ width: '100%', background: '#F7F8FC', border: '1.5px solid #E2E8F0', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', outline: 'none', minHeight: '100px', resize: 'vertical' }}
                placeholder="Write your announcement here..." required />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ fontSize: '11px', fontWeight: 800, color: '#64748B', textTransform: 'uppercase', display: 'block', marginBottom: '5px' }}>Target Class (optional)</label>
              <select value={form.target_class} onChange={e => setForm(p => ({ ...p, target_class: e.target.value }))}
                style={{ width: '100%', background: '#F7F8FC', border: '1.5px solid #E2E8F0', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', outline: 'none' }}>
                <option value="">All Classes</option>
                {[6,7,8,9,10].map(c => <option key={c} value={c}>Class {c} Only</option>)}
              </select>
            </div>
            <button type="submit" disabled={loading}
              style={{ width: '100%', background: '#FF6B00', color: 'white', border: 'none', borderRadius: '8px', padding: '12px', fontSize: '14px', fontWeight: 800, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Sending...' : '📢 Send Announcement'}
            </button>
          </form>
        </div>

        {/* Sent announcements */}
        <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '14px', padding: '20px' }}>
          <div style={{ fontSize: '14px', fontWeight: 800, marginBottom: '16px' }}>📋 Recent Announcements</div>
          {sent.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#64748B' }}>
              <div style={{ fontSize: '36px', marginBottom: '10px' }}>📭</div>
              <div style={{ fontWeight: 700 }}>No announcements yet</div>
              <div style={{ fontSize: '12px', marginTop: '4px' }}>Announcements you send will appear here</div>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {sent.map((a, i) => (
                <div key={i} style={{ border: '1px solid #E2E8F0', borderRadius: '10px', padding: '12px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
                    <div style={{ fontSize: '13px', fontWeight: 800 }}>{a.title}</div>
                    <span style={{ fontSize: '10px', fontWeight: 700, background: '#E8F0FB', color: '#1A3C6E', borderRadius: '20px', padding: '2px 8px', whiteSpace: 'nowrap', marginLeft: '8px' }}>
                      {a.target_class ? `Class ${a.target_class}` : 'All Classes'}
                    </span>
                  </div>
                  <div style={{ fontSize: '12px', color: '#64748B', lineHeight: 1.5 }}>{a.message}</div>
                  <div style={{ fontSize: '10px', color: '#94A3B8', marginTop: '6px' }}>
                    Sent {new Date(a.created_at).toLocaleString('en-IN')}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </AdminShell>
  );
};

export default AdminAnnouncementsPage;
